import Model from '@/lib/data/Model';
import User from '@/data/User';// eslint-disable-line
import Representative from '@/data/Representative';// eslint-disable-line
import Organization from '@/data/Organization';
import AccessRole from '@/data/AccessRole';

class Context extends Model {
    static idProperty = 'id';

    fields = [
        {
            name: 'user',
            association: {
                type: 'one',
                model: User,
            },
        },
        {
            name: 'roles',
            association: {
                type: 'many',
                model: AccessRole,
            },
        },
        {
            name: 'organization',
            association: {
                type: 'one',
                model: Organization,
            },
        },
        {
            name: 'users',
            association: {
                type: 'many',
                model: User,
            },
        },
        {
            name: 'representatives',
            association: {
                type: 'many',
                model: Representative,
                collectionConfig: {
                    url: '/representative/list',
                },
            },
        },
        {
            name: 'organization_id',
        },
        {
            name: 'isAdmin',
            defaultValue: false,
            type: 'bool',
        },
        {
            name: 'isOrganizationRoot',
            defaultValue: false,
            type: 'bool',
        },
    ];

    get isRootAdmin() {
        return this.isOrganizationRoot && this.isAdmin;
    }

    get roleName() {
        const roles = this.roles || [];
        return roles.length ? roles[0].name : null;
    }

    hasAccess(functionNames, accessCode) {
        let granted = false;

        functionNames = [].concat(functionNames);

        this.roles.forEach((role) => {
            role.functions.forEach((func) => {
                if (functionNames.indexOf(func.function_name) > -1) {
                    const validAccess = accessCode & func.valid_access_code;// eslint-disable-line
                    granted =
                        granted ||
                        (validAccess !== 0 && (validAccess & func.access_code) === validAccess);// eslint-disable-line
                }
            });
        });

        return granted;
    }

    canRead(...args) {
        return this.hasAccess.call(this, Array.from(args), 1);
    }

    canCreate(functionName) {
        return this.hasAccess(functionName, 2);
    }

    canUpdate(functionName) {
        return this.hasAccess(functionName, 4);
    }

    canDelete(functionName) {
        return this.hasAccess(functionName, 8);
    }

    constructor(data) {
        super(data);
        this.init();
    }

    api = [
        {
            name: 'read',
            url: '/context/get',
            method: 'GET',
        },
        {
            name: 'verifyEmail',
            url: '/context/verify_email',
            method: 'GET',
            params: ['organization_id'],
        },
        {
            name: 'heartbeat',
            url: '/web/connect',
            method: 'GET',
            associated: false,
        },
    ];
}

export default Context;
